// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSearchModelResponse {
    static getAttributeTypeMap() {
        return PrescriberSearchModelResponse.attributeTypeMap;
    }
}
PrescriberSearchModelResponse.discriminator = undefined;
PrescriberSearchModelResponse.additionalProperties = false;
PrescriberSearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PrescriberSearchResponseModel"
    },
];
//# sourceMappingURL=prescriberSearchModelResponse.js.map